import React, {useState} from "react";

import "./Współpraca.css";
import MiniNav from "../../components/Navbar/MiniNav";
import Modalform from "../Formularz/Modalform";

const TreningP = () => {
    const [openModal, setOpenModal] = useState(false);

    return (
        <>
            <MiniNav />
            <div className="app__bg app__wrapper section__padding">
                <div className="app__wsp">
                    <div className="h1">
                        <h1 className="app__wsp_h1">Współpraca Online</h1>
                    </div>
                    <ul className="whiteee">
                        <li>Współpraca może trwać 1,3 lub 6 miesięcy</li>
                        <li>
                            Indywidualny plan treningowy dostosowany do Twoich
                            celów treningowych
                        </li>
                        <li>
                            Spersonalizowany plan dietetyczny dopasowany do
                            Twoich preferencji żywieniowych
                        </li>
                        <li>Wsparcie merytoryczne</li>
                        <li>
                            Szybsze i łatwiejsze osiągnięcie Twoich celów
                            sylwetkowych, kondycyjnych czy zdrowotnych
                        </li>
                        <li>Stały kontakt z trenerem</li>
                        <li>
                            Regularne monitorowanie Twoich efektów i analiza
                            postępów
                        </li>
                        <li>
                            Możliwość pomiaru na analizatorze składu ciała
                            InBody
                        </li>
                    </ul>
                    <div className="butto">
                        <button
                            onClick={() => setOpenModal(true)}
                            className="customm__butto"
                        >
                            Poznaj ofertę
                        </button>
                        <Modalform
                            open={openModal}
                            onClose={() => setOpenModal(false)}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default TreningP;
